import React from "react";

const Buttons = ({ data }) => {
    return (
        <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
            {
                data.buttons.map((buttons, index) => {

                    const customClass = index === 0 ? 'custom-button_for_application' : index === 1 ? 'custom-button_to_calculator' : '';

                    return (
                        <button key={index} className={`relative group p-5 lg:h-32 md:h-24 rounded-2xl shadow-lg flex flex-col ${customClass}`}
                                onClick={() => window.location.replace(buttons.button_url_source)}
                            >
                            <span className="font-medium mt-auto text-nowrap lg:text-[36px] md:text-[28px] text-[24px]">
                                {buttons.text}
                            </span>              
                            <img className="absolute right-2 top-3 p-2.5 transition-opacity duration-500 ease-linear 
                                opacity-100 group-hover:opacity-0" src={buttons.arrow} alt="arrow"
                            />
                            <img className="absolute right-2 top-3 p-2.5 transition-opacity duration-500 ease-linear 
                                opacity-0 group-hover:opacity-100" src={buttons.arrow_hover} alt="arrow"
                            />   
                        </button>
                    );
                })
            }
        </div>
    );
};

export default Buttons;